// src/admin/components/AssetSelectionCard.jsx
import React from 'react';
import PropTypes from 'prop-types';
import AssetBadge from '../../shared/components/AssetBadge';
import { formatAddress, hasAddress } from '../../shared/utils/formatAddress';

/**
 * AssetSelectionCard
 * Displays asset details with a badge and handles click for selection.
 */
export default function AssetSelectionCard({ asset, onClick }) {
  return (
    <div
      className="card mb-2 shadow-sm"
      role="button"
      onClick={() => onClick(asset)}
    >
      <div className="card-body">
        <div className="d-flex justify-content-between align-items-start">
          <h6 className="mb-1 fw-semibold">{asset.asset_name} </h6>
          <AssetBadge asset={asset} />
        </div>
        {hasAddress(asset) && (
          <p className="mb-1 text-muted small">
            <i className="bi bi-geo-alt me-1"></i>
            {formatAddress(asset, { fallback: '' })}
          </p>
        )}
        <div className="small text-muted">
          <i className="bi bi-building me-1"></i>
          {asset.asset_make}
          <i className="bi bi-box ms-3 me-1"></i>
          {asset.asset_model}
        </div>
      </div>
    </div>
  );
}

AssetSelectionCard.propTypes = {
  asset: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    asset_name: PropTypes.string,
    street_address: PropTypes.string,
    asset_make: PropTypes.string,
    asset_model: PropTypes.string,
    asset_ext_id: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  }).isRequired,
  onClick: PropTypes.func.isRequired
};